export const OPTIONS = {
  BILLING: {
    YEARLY: 'Y',
    MONTHLY: 'M',
  },
  EDITIONS: {
    STANDARD: 'S',
    ENTERPRISE: 'E',
  },
  BUYING_FOR: {
    SELF: 'self',
    TEAM: 'team',
    DOMAIN: 'domain',
  },
  PAYMENT: {
    STRIPE: 'Stripe',
    PADDLE: 'Paddle',
    RAZORPAY: 'RazorPay',
    PAYPAL: 'PayPal',
  },
  ORDER: {
    CHECK_CONNECTION: 'check_connection',
    ACTION: 'action',
    INIT: 'init',
    CREATE: 'create',
    UPDATE: 'update',
    VERIFY: 'verify',
    COMPLETE: 'complete',
    GET_INVOICE: 'get_invoice',
    UPDATE_INVOICE: 'update_invoice',
  },
};

export const FIELDS = {
  TOTAL_AMOUNT: 'amount',
  COUNTRY: 'country',
  CURRENCY: 'currency',
  EMAIL: 'email',
  TITLE: 'title',
  SKU: 'sku',
  USERS: 'users',
  BILLING: 'billing',
  EDITION: 'edition',
  BUYING_FOR: 'buying_for',
  PAYMENT_MODE: 'payment_mode',
  CART_ID: 'cart_id',
  VENDOR_ID: 'vendor_id',
  SUBSCRIPTION_ID: 'subscription_id',
  USER_ID: 'user_id',
  RECEIPT_URL: 'receipt_url',
  PAYER_EMAIL: 'payer_email',
  PAYER_ADDRESS: 'payer_address',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
  LICENSE_KEY: 'license_key',
  SESSION_ID: 'session_id',
  CART_TOKEN: 'cart_token',
  USE_COUPON: 'use_coupon',
  PARTNER_ID: 'partner_id',
  AFFILIATE_ID: 'affiliate_id',
  PAYMENT_URL: 'pay_url',
  PAYMENT_ATTEMPT: 'payment_attempt',
  IS_CONNECTED: 'is_connected',
};

export const INVOICE = {
  NAME: 'invoice_name',
  ADDRESS_1: 'invoice_address_1',
  ADDRESS_2: 'invoice_address_2',
  STATE: 'invoice_state',
  CITY: 'invoice_city',
  ZIP: 'invoice_zip',
  COUNTRY: 'invoice_country',
  EMAIL: 'invoice_email',
  PHONE: 'invoice_phone',
  GST: 'invoice_gst',
  NOTES: 'invoice_notes',
  IP: 'invoice_ip',
};

export const META = {
  STEP: 'step',
  CODE: 'code',
  HASH: 'hash',
  IS_INLINE: 'is_inline',
  IS_PROCESSING: 'is_processing',
  IS_MONTHLY: 'is_monthly',
  IS_EXEMPT: 'is_exempt',
};

export const SERVICE_URL = 'https://pay.digitalinspiration.com';

export const EMAIL = 'support@digitalinspiration.com';
